function ExpiredInvite(){

    return(
        <>
            <h1 style={{borderBottom: "none"}}>Invite has expired.</h1>
        </>
    )
}

export default ExpiredInvite;